import React from 'react'

import InputAdornment from 'components_new/atoms/InputAdornment'
import TextField from 'components_new/atoms/TextField'

import FormulaTypeButton from 'components_new/molecules/FormulaBlock/TypeButton'
import { OptionProps } from 'components_new/molecules/OptionsMenu'

export interface FormulaConstantFieldProps {
  onChange: (value: string) => void
  /** What the operand can be changed into, behind the pencil. */
  typeOptions: OptionProps[]
  value: number | string
}

/**
 * A constant operand: a plain number, with the pencil that changes what the
 * operand is where the field's own icon would be.
 */
const FormulaConstantField = (props: FormulaConstantFieldProps) => {
  const { onChange, typeOptions, value } = props

  return (
    <TextField
      fullWidth={true}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <FormulaTypeButton options={typeOptions} />
          </InputAdornment>
        ),
        inputMode: 'numeric'
      }}
      onChange={(event) => onChange(event.target.value)}
      placeholder="0"
      size="small"
      sx={{ minWidth: 128, my: 0 }}
      type="number"
      value={value}
    />
  )
}

export default FormulaConstantField
